module.exports = __webpack_public_path__ + "media/images/dashboard-icon-529d118af1461e44cf8dc910bd76c211.svg";